import {RouterModule, Routes} from '@angular/router';
import {TourComponent} from './components/tour.component';
import {ModuleWithProviders} from '@angular/core';
import {HomeComponent} from './components/home.component';
import {AboutComponent} from './components/about.component';
import {CommunityComponent} from './components/community.component';
import {FeedbackComponent} from './components/feedback.component';
import {ContactsComponent} from './components/contacts.component';
import {WishlistComponent} from './components/wishlist.component';
import {FeaturesComponent} from './components/features.component';
import {TourGuard} from './services/tour.guard';
import {BuilderListComponent} from './components/builder-list.component';
import {SharedWishlistComponent} from './components/shared-wishlist.component';
import {TagComponent} from './components/tag.component';

const APP_ROUTES: Routes = [
  { path: 'builders' , component: BuilderListComponent },
  { path: ':builder/:model/about', canActivate: [TourGuard], component: AboutComponent },
  { path: ':builder/:model/community', canActivate: [TourGuard], component: CommunityComponent },
  { path: ':builder/:model/contacts', canActivate: [TourGuard], component: ContactsComponent },
  { path: ':builder/:model/feedback', canActivate: [TourGuard], component: FeedbackComponent },
  { path: ':builder/:model/wishlist', canActivate: [TourGuard], component: WishlistComponent },
  { path: ':builder/:model/features', canActivate: [TourGuard], component: FeaturesComponent },
  { path: ':builder/:model/tour/video', canActivate: [TourGuard], component: TourComponent },
  { path: ':builder/:model/tour/3d', canActivate: [TourGuard], component: TourComponent },
  { path: ':builder/:model/shared/:wishlistkey', component: SharedWishlistComponent },
  // direct tags
  { path: ':builder/:model/direct', component: TagComponent, pathMatch: 'full' },
  { path: ':builder/:model/direct/video', children: [ { path: '**', component: TagComponent, pathMatch: 'full' } ] },
  { path: ':builder/:model/direct/scene/:sceneid', component: TagComponent, pathMatch: 'full'  },
  { path: ':builder/:model/direct/scene/:sceneid/option/:optionid', component: TagComponent, pathMatch: 'full' },
  // onsite tags catch (error handling)
  { path: ':builder/:model/onsite', component: TagComponent, pathMatch: 'full' },
  { path: ':builder/:model/onsite/video', children: [ { path: '**', component: TagComponent, pathMatch: 'full' } ] },
  { path: ':builder/:model/onsite/scene/:sceneid', component: TagComponent, pathMatch: 'full'  },
  { path: ':builder/:model/onsite/scene/:sceneid/option/:optionid', component: TagComponent, pathMatch: 'full' },
  // legacy support
  { path: ':builder/:model/embed.php', component: HomeComponent },
  { path: ':builder/:model/tour.php', component: HomeComponent },
  { path: ':builder/:model', component: HomeComponent },
  { path: ':alias' , component: HomeComponent },
  { path: '' , component: HomeComponent }
];

export const routing: ModuleWithProviders = RouterModule.forRoot(APP_ROUTES);



// WEBPACK FOOTER //
// ./src/app/app.routing.ts